<template>
  <div id="app">
    <router-view />
    <portal-target name="portal" />
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    document.title = "Hack the 6ix Admin Dashboard"
  }
};
</script>

<style lang="scss">
@use '~@hackthe6ix/vue-ui/styles/colors.scss';
@use '~@hackthe6ix/vue-ui/styles/fonts.scss';

@include fonts.load('~@hackthe6ix/vue-ui/static/');
@include colors.load;

body {
  margin: 0;
}
</style>
